import React from 'react';
import { useFormContext } from 'react-hook-form';

const Checkbox = ({
    label,
    name,
    rules = {},
    className = '',
    checkboxClassName = '',
    labelClassName = '',
    ...rest
}) => {
    const { register } = useFormContext();

    return (
        <div className={`checkbox-wrapper ${className}`} style={{ position: 'relative' }}>
            <label htmlFor={name} className={`checkbox-label ${labelClassName}`}>
                <input
                    id={name}
                    name={name}
                    type="checkbox"
                    {...register(name, rules)}
                    className={`checkbox ${checkboxClassName}`}
                    {...rest}
                />
                {label}
            </label>
        </div>
    );
};

export default Checkbox;


